import React from "react";
import Accessories from "../../components/HomeComponents/Accessories";
import BestSellerBrands from "../../components/HomeComponents/BestSellerBrands";
import CategoriesTop from "../../components/HomeComponents/CategoriesTop";
import ClothingCollection from "../../components/HomeComponents/ClothingCollection";
import DesignerOfWeek from "../../components/HomeComponents/DesignerOfWeek";
import Footwear from "../../components/HomeComponents/Footwear";
import HandBags from "../../components/HomeComponents/HandBags";
import NewArrivals from "../../components/HomeComponents/NewArrivals";
import ProductsRecent from "../../components/HomeComponents/ProductsRecent";
import TestimonialsSlider from "../../components/HomeComponents/TestimonialsSlider";
import TodaySalesBanner from "../../components/HomeComponents/TodaySalesBanner";
import Placeholder from "../../components/Placeholders/Placeholder";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Autoplay, Navigation, Pagination } from "swiper";
import { useDispatch , useSelector } from "react-redux";
import { setOpenPoup } from "../../store/actions/popupActions";


// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";

function DesktopHome({ isLoading, elements }) {
  const authState = useSelector((state) => state.auth);// get the auth state from the redux store
  const dispatch = useDispatch();

  const openAuthModal = () => {
    dispatch(setOpenPoup("signup"));
  }

  return (
    <>
      <div id="us-homepage-wrapper">
        <div className="clearfix"></div>
        <div className="bottom-spacer-double"></div>
        <div className="clearfix"></div>
        {/* ======================= TOP BANNER ======================= */}
        {isLoading ? (
          <section className="banner home-banner mt-15 top-sales-banner">
            <div className="container-fluid mt-10">
              <div className="row">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
            </div>
          </section>
        ) : (
          <TodaySalesBanner
            componentData={elements[1] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}
        {/* ======================= /TOP BANNER ======================= */}

        {/* ======================= DESIGNER OF THE MONTHS ======================= */}
        <div className="clearfix"></div>

        {/* Designer of Week Section */}
        {isLoading ? (
          <section className="designer-of-the-week spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <DesignerOfWeek
            componentData={elements[3] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}

        {/* ======================= /DESIGNER OF THE MONTHS ======================= */}
        {/* ======================= CLOTHING COLLECTION ======================= */}
        {/* New Arrivals Section */}
        {isLoading ? (
          <section className="designer-of-the-week spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <ClothingCollection
            componentData={elements[4] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}
        {/* ======================= /CLOTHING COLLECTION ======================= */}

        {/* ======================= FOOTWEAR COLLECTION ======================= */}
        {isLoading ? (
          <section className="accessories spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <Footwear
            componentData={elements[8] || {}}
            getTargetUrl={getTargetUrl}
            showShopNow={true}
          />
        )}
        {/* ======================= /FOOTWEAR COLLECTION ======================= */}

        {/* ======================= HANDBAGS COLLECTION ======================= */}
        {isLoading ? (
          <section className="clothing spacer">
            <div
              className="main-heading-center"
              style={{ marginBottom: "20px" }}
            >
              <h4>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h4>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
              <div className="row mt-30">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
              <div className="row mt-30">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
            </div>
          </section>
        ) : (
          <HandBags
            componentData={elements[7] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}
        {/* ======================= /HANDBAGS COLLECTION ======================= */}

        {/* ======================= ACCESSORIES COLLECTION ======================= */}

        {isLoading ? (
          <section className="accessories spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="main-heading-center mt-30">
                  <h4 className="">
                    <Placeholder
                      variant="text"
                      width={100}
                      className="mx-auto"
                    />
                  </h4>
                </div>
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>
              </div>

              <div className="row">
                <div className="main-heading-center mt-30">
                  <h4 className="">
                    <Placeholder
                      variant="text"
                      width={100}
                      className="mx-auto"
                    />
                  </h4>
                </div>
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <Accessories
            heading="MEN"
            componentData={elements[5] || {}}
            getTargetUrl={getTargetUrl}
            showShopNow={true}
          />
        )}
        {/* ======================= /ACCESSORIES COLLECTION ======================= */}

        {/* ======================= HOW DARVEYS WORKS ======================= */}
        <section className="us-darveys-work-section">
          <div className="us-section-heading-area">
            <h2 className="us-heading">How Darveys Works</h2>
            <p className="us-subheading">
            Indulge in coveted designer pieces from 300+ luxury fashion boutiques, bringing the latest collections right to your doorstep
            </p>
          </div>
          <div className="us-darveys-work-iframe-wrapper">
            <div className="iframe-wrapper">
              <iframe
                src="https://www.youtube.com/embed/-OZzAMc1fHA?si=7TKgZV6H6co5EvwS"
                title="Dive Into Your Luxury Fashion Journey | Experience Darveys"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              />
            </div>
          </div>
        </section>
        {/* ======================= /HOW DARVEYS WORKS ======================= */}

        {/* ======================= /HOW DARVEYS WORKS ======================= */}
        {  (!(authState?.token && authState?.isAuthenticated && authState?.user))  && (
          <a  onClick={openAuthModal}>
            <section className="us-darveys-bottom-banner" onClick={openAuthModal}>
            <picture>
              <source
                media="(min-width:565.1px)"
                srcset="https://skin.darveys.com/assets/images/Sign_Up_Now_Banner.jpg"
              />
              <source
                media="(max-width: 565px)"
                srcset="https://skin.darveys.com/assets/images/Sign_Up_Now_Banner.jpg"
              />
              <img src="https://skin.darveys.com/assets/images/Sign_Up_Now_Banner.jpg" alt="" />
            </picture>
            </section>
          </a>
        )} 

        {/* ======================= /HOW DARVEYS WORKS ======================= */}

        {/* ======================= DARVEYS REVIEWS ======================= */}
        <section className="us-darveys-review-section">
          <div className="us-section-heading-area">
            <h2 className="us-heading">Darveys Reviews</h2>
            <p className="us-subheading us-subheading-wide">
              Your trust is our greatest reward, and your honest reviews inspire us <br/>to consistently elevate your luxury shopping experience
            </p>
          </div>
          <div className="us-darveys-review-wrapper">
            <div className="rating-text">
              <span className="current-rating">4.5</span>/5
            </div>
            <div className="stars-wrapper">
              <ul>
                <li>
                  <img src="https://media.darveys.com/fill-star.png" alt="failed" />
                </li>
                <li>
                  <img src="https://media.darveys.com/fill-star.png" alt="failed" />
                </li>
                <li>
                  <img src="https://media.darveys.com/fill-star.png" alt="failed" />
                </li>
                <li>
                  <img src="https://media.darveys.com/fill-star.png" alt="failed" />
                </li>
                <li>
                  <img src="https://media.darveys.com/half-star.png" alt="failed" />
                </li>
              </ul>
            </div>
          </div>
        </section>
        {/* ======================= /DARVEYS REVIEWS ======================= */}
      </div>
      <div id="home-page">
        <div className="clearfix"></div>
        <div className="bottom-spacer-double"></div>
        <div className="clearfix"></div>
        {/* Recently Viewed Section */}
        {/* {isLoading ? (
          <section className="designer-of-the-week spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />
                  <Placeholder variant="text" width={200} className="mx-auto" />
                  <Placeholder variant="text" width={200} className="mx-auto" />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder variant="text" width={200} className="mx-auto" />
                  <Placeholder variant="text" width={200} className="mx-auto" />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder variant="text" width={200} className="mx-auto" />
                  <Placeholder variant="text" width={200} className="mx-auto" />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <ProductsRecent componentData={elements[11] || {}} />
        )} */}
      </div>
    </>
  );
}

const getTargetUrl = (data) => {
  if (!data && !data.click_target) {
    return "#0";
  }

  if (data.click_target === "category") {
    const catId = data.url_path || "";
    return "/catalog/" + catId;
  }

  return "#0";
};

export default DesktopHome;
